import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../ui/dialog';
import { FabricSwatchGallery } from './FabricSwatchGallery';

export const FabricGalleryDialog = ({ open, onOpenChange, brands, selectedColorId, onSelect }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-6xl w-[96vw] h-[90vh] flex flex-col p-0 gap-0" data-testid="fabric-gallery-dialog">
      <DialogHeader className="px-6 pt-6 pb-2">
        <DialogTitle className="font-serif text-2xl">Browse all fabrics</DialogTitle>
        <DialogDescription>Every fabric available for this product — real swatches and AI room views for each color. The full catalog for all products is on the Fabrics page.</DialogDescription>
      </DialogHeader>
      <div className="flex-1 min-h-0 px-6 pb-6">
        <FabricSwatchGallery
          brands={brands}
          selectedColorId={selectedColorId}
          onSelect={(entry) => { onSelect(entry); onOpenChange(false); }}
          selectLabel="Use this fabric"
          className="h-full"
        />
      </div>
    </DialogContent>
  </Dialog>
);

export default FabricGalleryDialog;
